'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Manager = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Manager, _Component);

  function Manager() {
    (0, _classCallCheck3.default)(this, Manager);
    return (0, _possibleConstructorReturn3.default)(this, (Manager.__proto__ || (0, _getPrototypeOf2.default)(Manager)).apply(this, arguments));
  }

  (0, _createClass3.default)(Manager, [{
    key: 'render',
    value: function render() {
      var styles = require('./Manager.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_components.MainNavigation, null),
        _react2.default.createElement(
          'div',
          { className: styles.main },
          this.props.children
        )
      );
    }
  }]);
  return Manager;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object.isRequired
}, _temp);
exports.default = Manager;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Manager/Manager.js
// module id = 1175
// module chunks = 0